import * as ActionTypes from '../actionTypes';
import apiActionCreator from '../../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../../common/util/errorUtils';
import * as MessageActions from '../../../common/messageBox/actions/actions';

// import {getUrlParameters} from '../../../common/util/urlParameters';
// import * as MessageActions from '../../../common/messageBox/actions/actions';

export const getWtsDealer = () => apiActionCreator({
  'endpoint': '/wts/catalog/dealer',
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_WTS_DEALER,
    ActionTypes.FETCHED_WTS_DEALER,
    [
      ActionTypes.FETCHED_WTS_DEALER_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});


export const updateWtsDealerStatus = (data) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': '/wts/catalog/dealerStatus',
      'authenticated': true,
      'types': [
        ActionTypes.UPDATING_WTS_DEALER_STATUS,
        [
          () => {
            dispatch(getWtsDealer());
            return {'type': ActionTypes.UPDATED_WTS_DEALER_STATUS};
          },
          MessageActions.addMessageBoxInfo('Concesionario modificado satisfactoriamente'),
        ],
        [
          ActionTypes.UPDATED_WTS_DEALER_STATUS_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'PUT',
      'contentType': 'application/json',
      'data': data,
    })
  );
};


export const changeWtsDealerSelected = (dealerSelected) => ({
  'type': ActionTypes.CHANGE_WTS_DEALER_SELECTED,
  'payload': dealerSelected,
});

export const updateWtsDealer = (data) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': '/wts/catalog/dealer',
      'authenticated': true,
      'types': [
        ActionTypes.UPDATING_WTS_DEALER,
        [
          () => {
            dispatch(getWtsDealer());
            return {'type': ActionTypes.UPDATED_WTS_DEALER};
          },
          MessageActions.addMessageBoxInfo('Concesionario modificado satisfactoriamente'),
        ],
        [
          ActionTypes.UPDATED_WTS_DEALER_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'PUT',
      'contentType': 'application/json',
      'data': data,
    })
  );
};


export const createWtsDealer = (data) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': '/wts/catalog/dealer',
      'authenticated': true,
      'types': [
        ActionTypes.CREATING_WTS_DEALER,
        [
          () => {
            dispatch(getWtsDealer());
            return {'type': ActionTypes.CREATED_WTS_DEALER};
          },
          MessageActions.addMessageBoxInfo('Concesionario creado satisfactoriamente'),
        ],
        [
          ActionTypes.CREATED_WTS_DEALER_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'POST',
      'contentType': 'application/json',
      'data': data,
    })
  );
};
